import { PATH_TRANSLATION, PATH_ROTATION, PATH_SCALE, PATH_POINTER } from './types.js';
import { createAnimationController } from '../skeleton/skeleton-updater.js';
import { _setTickAnimationImpl } from './animation-tick.js';

const DEFAULT_FRAME_RATE = 60;
function playAnimation(group) {
  group.isPlaying = true;
  group._stopped = false;
}
function pauseAnimation(group) {
  group.isPlaying = false;
}
function stopAnimation(group) {
  group.isPlaying = false;
  group.currentTime = 0;
  group._stopped = true;
}
function syncControllerFromGroup(group, ctrl) {
  ctrl.time = group.currentTime;
  ctrl.playing = group.isPlaying;
  ctrl.speedRatio = group.speedRatio;
  ctrl.loop = group.loopAnimation;
  ctrl._setMask?.(group.mask ?? null);
}
function tickAnimationCore(group, deltaMs, engine) {
  if (!group._stopped && group._ctrl) {
    syncControllerFromGroup(group, group._ctrl);
    group._ctrl.tick(deltaMs, engine);
    group.currentTime = group._ctrl.time;
  }
}
function tickAnimationImpl(group, deltaMs, engine) {
  if (group._animationManager) {
    return;
  }
  tickAnimationCore(group, deltaMs, engine);
}
function _installTickAnimation() {
  _setTickAnimationImpl(tickAnimationImpl);
}
function goToFrame(group, frame, engine) {
  const ctrl = group._ctrl;
  group.currentTime = frame / (group.frameRate || DEFAULT_FRAME_RATE);
  group.isPlaying = false;
  if (ctrl) {
    syncControllerFromGroup(group, ctrl);
    if (engine || !group._stopped || !group._gltfMixer) {
      ctrl.tick(0, engine);
      group.currentTime = ctrl.time;
    }
  }
}
function createAnimationGroups(animData) {
  const { clips, nodes, skeletons, morphBindings, nodeTargets, excludedNodeIndices, nodeNames, boneOverrides } = animData;
  if (clips.length === 0) {
    return [];
  }
  _installTickAnimation();
  return clips.map((clip, clipIndex) => {
    const ctrl = createAnimationController(clip, nodes, skeletons, morphBindings, nodeTargets, excludedNodeIndices, boneOverrides, nodeNames);
    const started = clipIndex === 0;
    const group = {
      name: clip.name || `animation_${clipIndex}`,
      duration: clip.duration,
      frameRate: clip.frameRate || DEFAULT_FRAME_RATE,
      isPlaying: started,
      currentTime: 0,
      targetedAnimations: clip.channels.map((ch) => {
        const nodeIndex = ch.nodeIdx >= 0 ? ch.nodeIdx : void 0;
        return {
          target: nodeIndex !== void 0 ? nodeTargets[nodeIndex] : void 0,
          targetName: nodeIndex !== void 0 ? nodeNames[nodeIndex] : void 0,
          nodeIndex,
          path: pathName(ch.path)
        };
      }),
      speedRatio: 1,
      loopAnimation: true,
      weight: 1,
      _ctrl: ctrl,
      _stopped: !started
    };
    group._gltfMixer = [clip, nodes, skeletons];
    return group;
  });
}
function pathName(path) {
  return path === PATH_TRANSLATION ? "translation" : path === PATH_ROTATION ? "rotation" : path === PATH_SCALE ? "scale" : path === PATH_POINTER ? "pointer" : "weights";
}

export { _installTickAnimation, createAnimationGroups, goToFrame, pauseAnimation, playAnimation, stopAnimation, tickAnimationCore };
//# sourceMappingURL=animation-group.js.map
